module.exports = __webpack_public_path__ + "static/media/texture (2).1a8a60ce.jpg";